import {Coordinate} from "./coordinate.model";

export class Sostegno {
  gid: number;
  codice: string;
  comune: string;
  idAtes: string;
  latitudine: number;
  longitudine: number;
}

export function getAverageLonLatSostegni (sostegni: Sostegno[]): Coordinate {
  // TODO: make a proper centroid
  if (sostegni.length === 0) return null;
  const latitude = sostegni.map((sost) => { return sost.latitudine}).reduce((previous, current, ) => {
    return previous + current;
  }, 0) / sostegni.length;
  const longitude = sostegni.map((sost) => { return sost.longitudine}).reduce((previous, current, ) => {
    return previous + current;
  }, 0) / sostegni.length;
  return {
    longitudine: longitude,
    latitudine: latitude
  }
}

